/* Copy-link extension. Horizon's dialog owns focus, Escape and scroll locking. */
class GomitoloProductShare extends HTMLElement {
  connectedCallback() { this.addEventListener('click', this.handleClick); }
  disconnectedCallback() { this.removeEventListener('click', this.handleClick); }
  handleClick = async (event) => {
    if (!(event.target instanceof Element)) return;
    const input = this.querySelector('[data-share-url]');
    const status = this.querySelector('[data-share-status]');
    if (!(input instanceof HTMLInputElement) || !(status instanceof HTMLElement)) return;
    if (event.target.closest('[data-share-open]')) {
      const canonical = document.querySelector('link[rel="canonical"]');
      const canonicalUrl = new URL(canonical?.getAttribute('href') || window.location.href);
      const url = canonicalUrl.pathname.includes('/products/') ? canonicalUrl : new URL(this.dataset.url, window.location.origin);
      const variant = this.closest('.product-details')?.querySelector('product-form-component input[name="id"]');
      url.search = '';
      if (variant?.value) url.searchParams.set('variant', variant.value);
      input.value = url.href;
      status.textContent = '';
    }
    if (event.target.closest('[data-share-copy]')) {
      try {
        await navigator.clipboard.writeText(input.value);
        status.textContent = status.dataset.success;
      } catch {
        input.focus();
        input.select();
        status.textContent = status.dataset.failure;
      }
    }
  };
}
if (!customElements.get('gomitolo-product-share')) customElements.define('gomitolo-product-share', GomitoloProductShare);
